import { rgba } from "polished";
import { css } from "styled-components";
const logitravelSearcherSkeletonStyles = {
    SearcherSkeletonWrapper: ()=>css`
		--searcher-skeleton-color-base: ${({ theme  })=>theme.colors.white.high};
		--searcher-skeleton-color-effect: ${({ theme  })=>rgba(theme.colors.white.lowest, 0.08)};
	`
};
export default logitravelSearcherSkeletonStyles;

//# sourceMappingURL=logitravel.js.map